import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import queryClient from '@app/queryClient';
import { opportunitiesApi } from '@modules/opportunities/entities/opportunity/api';
import { UpdateOpportunityDTO } from '@modules/opportunities/entities/opportunity/api/dto/updateOpportunity.dto';
import { t } from 'i18next';

const useUpdateOpportunity = (callbackFn?: () => void) => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['updateOpportunity'],
    mutationFn: (data: { opportunityId: string; body: UpdateOpportunityDTO | UpdateOpportunityDTO<'ES'> }) =>
      opportunitiesApi.updateOpportunity(data.opportunityId, data.body),
    onSuccess: async (data) => {
      await Promise.all([
        queryClient.refetchQueries({ queryKey: ['clientOpportunity', data.opportunity_external_id] }),
        queryClient.refetchQueries({ queryKey: ['vaultConfig', data.opportunity_external_id] }),
        queryClient.refetchQueries({ queryKey: ['vault', data.opportunity_external_id] }),
        queryClient.refetchQueries({ queryKey: ['vault-storage', data.opportunity_external_id] })
      ]);
      queryClient.invalidateQueries({ queryKey: ['bankDigitalDocs', data.opportunity_external_id] });
      callbackFn?.();
      toast('info', { message: t('opportunity.mutations.clientUpdatedSuccess') });
    },
    onError: () => {
      toast('error', { message: t('opportunity.mutations.clientUpdatedFail') });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useUpdateOpportunity;
